import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { createenquiry, getenquiry } from "../../slices/enquiry";
import { getregion } from "../../slices/setting";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import CallIcon from '@mui/icons-material/Call';
import MessageIcon from '@mui/icons-material/Message';
import EmailIcon from '@mui/icons-material/Email';
import BasicTabs from "../../components/tabs/Enquirytab";
import { getdemobyid } from "../../slices/demo";

const Viewdemo = ({ setLoader, show }) => {

  const params = useParams();

  const id = params.id;

  const {demoDetail: viewData} = useSelector((state) => state.demo) || [];

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const arrowBack = () => {
    navigate(-1);
  };

  useEffect(()=>{
    setLoader(true)
      dispatch(getdemobyid(id))
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])

  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px" }}>
      <Box>
        <Grid container spacing={3} sx={{ paddingBottom: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5" sx={{fontWeight:'bold'}}>View Demo</Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ paddingTop: 3, display: "flex", alignItems: "center" }}
          >
            <Typography variant="h6">
              {viewData?.customer_name}
            </Typography>
            <Typography
              variant="p"
              sx={{
                bgcolor: "#0b4c7c",
                color: "#fff",
                px: 1,
                borderRadius: "10px",
                ml: 1,
              }}
            >
              {viewData?.demo_no}
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ paddingTop: 3, display: "flex", alignItems: "center" }}
          >
            <Typography variant="h6">
              Enquiry Date: {viewData?.enquiry_date}
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ paddingTop: 3, display: "flex", alignItems: "center" }}
          >
            <Typography variant="h6">
              Demo Date: {viewData?.demo_date}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2">Phone Number</Typography>
            <Typography variant="body1">{viewData?.mobile_no}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2">Model Family</Typography>
            <Typography variant="body1">{viewData?.model_family}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2">Model Code</Typography>
            <Typography variant="body1">{viewData?.model_code || "-"}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2">Model Variant</Typography>
            <Typography variant="body1">{viewData?.model_variant}</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12}>
                        <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Feedback Details</Typography>
                      </Grid>
                      <Grid item xs={1}>
                            <Typography>
                              SR.No
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography>
                              Attribute
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography>
                              Rating
                            </Typography>
                        </Grid>
                        <Grid item xs={5}>
                            <Typography>
                              Remarks
                            </Typography>
                        </Grid>
                      <Grid item xs={12}>
                      {viewData?.feedback_details.map((vechile, index) => (
                        <Grid container spacing={2} marginBottom={2} alignItems={'center'}>
                        <Grid item xs={1}>
                            <Typography>
                              {index+1}
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                            inputProps={{
                              readOnly: true
                            }}
                            size="small"
                            fullWidth
                            placeholder="attribute"
                            id="outlined-basic"
                            variant="outlined"
                            name={`feedback_details[${index}].name`}
                                  value={vechile.attribute}
                          />
                            </Grid>
                            <Grid item xs={3}>
                            <TextField
                            inputProps={{
                              readOnly: true
                            }}
                            size="small"
                            fullWidth
                            placeholder="Rating"
                            value={vechile.rating}
                            id="outlined-basic"
                            variant="outlined"
                            name={`feedback_details[${index}].rating`}
                                 
                                  type="number"
                                                  onInput={(e) => {
                                                e.target.value = e.target.value.slice(0, 10);
                                              }}
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              sx={{
                                '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
                                  WebkitAppearance: 'none',
                                  margin: 0,
                                },
                                '& input[type="number"]': {
                                  MozAppearance: 'textfield', // For Firefox
                                },
                              }}
                          />
                            </Grid>
                            
                            <Grid item xs={5}>
                            <TextField
                            inputProps={{
                              readOnly: true
                            }}
                            size="small"
                            fullWidth
                            placeholder="Remarks"
                            id="outlined-basic"
                            variant="outlined"
                            name={`feedback_details[${index}].remarks`}
                                  value={vechile.remarks}
                                 
                          />
                            </Grid>
                        </Grid>
                      ))}
                      </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Viewdemo;
